import OneSignal from "react-onesignal"
import { onesignal } from "../config"
import axios from "axios"

class OneSignalHelper {
  initialize = () => {
    return OneSignal.init(onesignal.options)
  }

  async getSubscriptionId() {
    try {
      return await OneSignal.getUserId();
    } catch (error) {
      console.error('Error getting subscription ID:', error);
      return null;
    }
  }

  async setUserIdentityExternalId(userId) {
    try {
      const subscriptionId = await this.getSubscriptionId();

      if (!subscriptionId) {
        console.error('No OneSignal subscription ID found');
        return;
      }

      const url = `https://api.onesignal.com/apps/${onesignal.options.appId}/subscriptions/${subscriptionId}/user/identity`;
      const options = {
        method: 'PATCH',
        headers: {
          'accept': 'application/json',
          'content-type': 'application/json'
        },
        data: JSON.stringify({
          identity: {
            external_id: userId
          }
        })
      };

      const response = await axios(url, options);
      return response.data;
    } catch (error) {
      console.error('Error setting user data in OneSignal:', error);
    }

  }

  async setUserData(user) {
    const enabled = await OneSignal.isPushNotificationsEnabled()
    if (enabled) {
      await OneSignal.setExternalUserId(user.id)
      await this.setUserIdentityExternalId(user.id.toString())
    }
  }

  async removerUserData(user) {
    const enabled = await OneSignal.isPushNotificationsEnabled()
    if (enabled) {
      await OneSignal.removeExternalUserId()
    }
  }
}

let _onesignalHelper = null

const initOneSignalHelper = () => {
  if (!_onesignalHelper) {
    _onesignalHelper = new OneSignalHelper()
  }
  return _onesignalHelper
}

const getOneSignalHelper = () => {
  return _onesignalHelper
}

export { initOneSignalHelper, getOneSignalHelper }
